import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const ballonTopLeftPath: PathObjectInterface = {
  mainPath: { x: -20, y: -10 },
  spline: [
    97, 77, 169, 157, 294, 203, 423, 202, 578, 237, 692, 271, 793, 308, 904, 327, 1025, 339, 1106,
    343, 1185, 319, 1280, 283, 1383, 320, 1470, 370, 1563, 386, 1583, 399,
  ],
}
